<template>
  <div class="page-empresa page-layout">
    <!-- Page Title -->
    <div class="page-layout__container page-title pb-3">
      <div class="container">
        <div class="row page-layout__content flex-column ">
          <h1>
            Nuestros Proyectos
          </h1>
          <p>
            Nuestra diferenciación es el apego a elevados estándares. <br />
            Nuestra capacidad analítica y el conocimiento probado es la garantía
            de resultados óptimos para el cliente.
          </p>
        </div>
      </div>
    </div>

    <gallery
      :list-images="GALLERY_IMAGES"
      :list-videos="GALLERY_VIDEOS"
      :list-media="GALLERY"
    />

    <!-- Quotes -->
    <div class="light--bg-blue">
      <section-quotes />
    </div>
  </div>
</template>

<script>
import SectionEmpresa from '@/components/layout/body-sections/section-empresa.vue';
import SectionQuotes from '@/components/layout/body-sections/section-quotes.vue';
import Gallery from '@/components/gallery.vue';
import { GALLERY, GALLERY_IMAGES, GALLERY_VIDEOS } from '@/config';

export default {
  name: 'Proyectos',
  components: {
    SectionEmpresa,
    SectionQuotes,
    Gallery,
  },
  data() {
    return {
      GALLERY_IMAGES,
      GALLERY_VIDEOS,
      GALLERY,
    };
  },
};
</script>

<style lang="scss">
.tabs {
  position: relative;
  margin: 0 auto;

  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: $gray;
    transition: transform 0.4s ease, width 0.4s ease;
  }

  &__item {
    display: inline-block;
    margin: 0 5px;
    padding: 10px;
    padding-bottom: 8px;
    font-size: 16px;
    letter-spacing: 0.8px;
    color: $gray;
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;

    &_active {
      color: $gray;
    }

    &:hover {
      border-bottom: 2px solid $gray;
      color: $gray;
    }

    &:focus {
      outline: none;
      border-bottom: 2px solid $gray;
      color: $gray;
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
